import airtable from './airtable.svg';
import contentful from './contentful.svg';
import databricks from './databricks.svg';
import googleAds from './googleads.svg';
import googleBigQuery from './googlebigquery.svg';
import googleTagManager from './googletagmanager.svg';
import intercom from './intercom.svg';
import jira from './jira.svg';
import looker from './looker.svg';
import mailchimp from './mailchimp.svg';
import make from './make.svg';
import meta from './meta.svg';
import mixpanel from './mixpanel.svg';
import mongodb from './mongodb.svg';
import notion from './notion.svg';
import sap from './sap.svg';
import snowflake from './snowflake.svg';
import wordpress from './wordpress.svg';
import zendesk from './zendesk.svg';

const ecosystemImages = {
  airtable,
  contentful,
  databricks,
  googleAds,
  googleBigQuery,
  googleTagManager,
  intercom,
  jira,
  looker,
  mailchimp,
  make,
  meta,
  mixpanel,
  mongodb,
  notion,
  sap,
  snowflake,
  wordpress,
  zendesk,
};

export default ecosystemImages;
